import { TIMELINE } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function TimelineSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="ARCHIVE LOG"
          title="这支档案队是怎么一点点长起来的"
          description="从几个人合并硬盘里的旧截图，到形成可检索的失效内容索引，中间用了六年时间。"
        />

        <ol className="mt-10 md:mt-16 grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-6">
          {TIMELINE.map((item, index) => (
            <li key={item.year} className="relative lg:pt-10">
              <span
                className="hidden lg:block absolute left-0 top-[6px] w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-500/20"
                aria-hidden="true"
              ></span>
              {index !== TIMELINE.length - 1 && (
                <span
                  className="hidden lg:block absolute left-3 top-[11px] right-[-1.5rem] h-px bg-background-300"
                  aria-hidden="true"
                ></span>
              )}
              <span className="lg:hidden w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-500/20 inline-block mb-4"></span>
              <div className="lg:border-l-0">
                <span className="font-heading text-3xl md:text-4xl text-primary-500">
                  {item.year}
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}